/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Import_TitleInputs */



/**
* | output |
* | --- |
* | "Translation File Import" |
*
* @param {Translation_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import_title = /** @type {((inputs?: Translation_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation de fichiers de traduction")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import der Übersetzungsdatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione del file di traduzione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт файла перевода")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de archivos de traducción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("翻译文件导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("翻訳ファイルのインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनुवाद फ़ाइल आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de arquivo de tradução")
	return /** @type {LocalizedString} */ ("Translation File Import")
});